module.exports = __webpack_public_path__ + "img/HPHC_logo.bc3e6518.svg";